import React from "react";
import { useNavigate } from "react-router-dom";

const FestivalPage = () => {

  const navigate = useNavigate();

  return (
    <div className="bg-[#0B1C3F] text-white  flex items-center justify-center px-4 sm:px-6 py-8">
      <div className="flex flex-col items-center w-full md:px-12 gap-6 sm:gap-8 md:flex-row">
        <img
          src="/arab.png"
          alt="Sheikh Zayed"
          className="w-full  md:w-[400px]"
        />
        <div className="w-full  ">
          <h1 className="pb-2 text-2xl sm:text-4xl font-semibold border-b-4 border-[#FFD367] text-center sm:text-left">
            THE FESTIVAL
          </h1>
          <p className="mt-4 text-xs leading-relaxed text-center sm:text-sm sm:text-left">
            The horizons of culture are ever-expanding, its paths are diversifying, and the need for its presence is increasing as a way for peoples to come together within a framework of tolerance, brotherhood and peace.
          </p>
          <p className="mt-4 text-xs leading-relaxed text-center sm:text-sm sm:text-left">
            The Sheikh Zayed Festival in Abu Dhabi comes within this framework, employing all its noble values, striving and aspiring towards common human development.
          </p>
          <p className="mt-4 text-xs leading-relaxed text-center sm:text-sm sm:text-left">
            This year, the Sheikh Zayed Festival renews its journey as one of the most important cultural and entertainment events in the country, carrying with it, and in it, all the lofty values for which the late Sheikh Zayed bin Sultan Al Nahyan, may God rest his soul, achieved - an integral part of his efforts to preserve the civilizational and cultural heritage of the Emirates and to consolidate national heritage and culture.
          </p>
          <p className="mt-4 text-xs leading-relaxed text-center sm:text-sm sm:text-left">
            The Festival is held under the distinguished patronage of His Highness Sheikh Mohamed bin Zayed Al Nahyan, President of the UAE, and the wise guidance of His Highness Sheikh Mansour bin Zayed Al Nahyan, UAE Vice President, Deputy Prime Minister and Chairman of the Presidential Court.
          </p>
          <p className="mt-4 text-xs leading-relaxed text-center sm:text-sm sm:text-left">
            The Festival returns this year with a huge variety of new cultural and entertainment events for the whole family to enjoy, in fun exciting settings that feature international music concerts, rare opportunities to learn about wildlife, a selection of amazing culinary experiences from all over the world, fun competitions and much, much more.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FestivalPage;
